<template>
  <div>
    <loading :active.sync="isLoading" color="#85344c"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/adm/planos">Planos</router-link>
          </li>
          <li class="breadcrumb-item active">Detalhe plano {{plano.name}}</li>
        </ol>

        <div class="row">
          <div class="col-md-12" v-if="mostraErro">
            <div class="alert alert-danger alert-dismissible" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <strong>Ops!</strong>
              <span>{{erroMensagem}}</span>
            </div>
          </div>
        </div>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-info-circle"></i>Informações do Plano
            </h2>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Nome</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Informe o nome do plano"
                  v-model="plano.name"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Código ANS</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Informe o código ANS"
                  v-model="plano.ans"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Foto do plano</label>
                <input
                  type="file"
                  class="form-control"
                  placeholder="Informe a foto"
                  @change="trocaFoto"
                />
              </div>
              <img :src="imagem_foto" class="img-thumbnail" />
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>Pessoa</label>
                <select class="form-control" @change="e => plano.tipo_plano = e.target.value" v-model="plano.tipo_plano">
                  <option value="0">Pessoa física</option>
                  <option value="1">Pessoa jurídica</option>
                  <option value="2">Plano Familiar</option>
                </select>
              </div>
            </div>
            <div class="col-12" v-if="plano.planos_vinculados && plano.planos_vinculados.length == 0">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Preço</label>
                    <money v-model="plano.price" v-bind="money" type="text" class="form-control"></money>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Taxa adesão</label>
                    <money v-model="plano.setup_fee" v-bind="money" type="text" class="form-control"></money>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Uniodonto</label>
                    <select
                      id="inputUniodonto"
                      v-model="plano.provider_id"
                      class="form-control"
                    >
                      <option
                        v-for="(operadora,index) in operadoras"
                        :key="index"
                        :value="operadora.id"
                      >{{operadora.name}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Status do plano</label>
                    <select class="form-control" v-model="plano.active">
                      <option :value="1">Ativo</option>
                      <option :value="0">Desativado</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Periodo de recorrência</label>
                    <select
                      class="form-control"
                      v-model="plano.unit_interval"
                    >
                      <option value="Monthly" selected>Mensal</option>
                      <option value="Bimonthly">Bimensal</option>
                      <option value="Quarterly">Trimestral</option>
                      <option value="SemiAnnual">Semestral</option>
                      <option value="Annual">Anual</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <label>Dias de Carência no Cartão de Crédito</label>
                    <input
                      type="number"
                      class="form-control"
                      placeholder="Informe os dias de carência desse plano"
                      v-model="plano.carencia"
                    >
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12" v-if="Number(plano.tipo_plano) === 2">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Uniodonto</label>
                  <select
                    id="inputUniodonto"
                    v-model="plano.provider_id"
                    class="form-control"
                    @change="getPlanosFromUniodonto()"
                  >
                    <option
                      v-for="(operadora,index) in operadoras"
                      :key="index"
                      :value="operadora.id"
                    >{{operadora.name}}</option>
                  </select>
                </div>
              </div>
              
              <div
                class="row"
                v-for="(plan, index) in plano.planos_vinculados"
                :key="index"
                v-if="Number(plano.tipo_plano) === 2"
              >
                <div class="col-md-12 mt-4 mb-4 text-center">
                  <h4>Plano Vinculado {{ index + 1 }}</h4>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <label>Plano Base</label>
                    <select v-model="plan.plans_id" class="form-control" @change="getValoresDoPlano(plan)">
                      <option
                        v-for="pl in listaPlanos"
                        :key="pl.id"
                        :value="pl.id"
                      >
                        {{ pl.name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <label>Preço</label>
                    <money v-model="plan.price" v-bind="money" class="form-control"></money>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <label>Taxa adesão</label>
                    <money v-model="plan.setup_fee" v-bind="money" class="form-control"></money>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <label>Carência (Crédito)</label>
                    <input v-model="plan.carencia" type="number" class="form-control" />
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label>Qtd. Miníma</label>
                    <input v-model="plan.qtd_min" type="number" class="form-control" />
                  </div>
                </div>

                <div class="col-md-1 d-flex align-items-center mt-3">
                  <button class="btn" @click="removePlanoVinculado(index)">
                    <i class="fa fa-minus"></i>
                  </button>
                </div>
              </div>
              <div class="col-md-12 text-center mt-4">
                <button class="btn " @click="addPlanoVinculado">
                  <i class="fa fa-plus"></i> Adicionar Plano Vinculado
                </button>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Dias de Carência no Boleto</label>
                <input
                  type="number"
                  class="form-control"
                  placeholder="Informe os dias de carência desse plano"
                  v-model="plano.carencia_boleto"
                >
              </div>
            </div>

             <div class="col-md-4">
              <div class="form-group">
                <label>Quantidade Pessoas por Plano</label>
                <input v-model="plano.qtd_membros" type="number" class="form-control" placeholder="Informe a quantidade de pessoas por plano. Ex: 6"/>
              </div>
            </div>
            
            <div class="col-md-4">
              <div class="form-group">
                <label>Quantidade Máxima de Pessoas por Plano</label>
                <input v-model="plano.qtd_max_membros" type="number" class="form-control" placeholder="Informe a quantidade máxima de pessoas por plano. Ex: 6"/>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Preço por boleto</label>
                <money v-model="plano.valor_boleto" v-bind="money" type="text" class="form-control"></money>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Número do Plano</label>
                <input v-model="plano.plan_number" type="text" class="form-control"></input>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Contrato</label>
                <input v-model="plano.contrato" type="text" class="form-control"></input>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Token Acesso</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Informe o token"
                  v-model="plano.TokenAcesso"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Recorrente</label>
                <select v-model="plano.recorrencia" class="form-control">
                  <option :value="1">Sim</option>
                  <option :value="0">Não</option>
                </select>
              </div>
            </div>

            <div class="col-md-12">
              <!-- <div v-if="Number(plano.tipo_plano) === 2"> -->
                <label>Atribuir desconto:</label>
                <div class="col-md-2">
                  <div class="form-check d-flex flex-column">
                    <input class="form-check-input" @change="plano.tipo_desconto='porcentagem'"  type="radio" name="exampleRadios" id="exampleRadios1" value="option1" :checked="plano.tipo_desconto=='porcentagem'">
                    <label class="form-check-label" for="exampleRadios1">
                      Porcentagem
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" @change="plano.tipo_desconto='abs'" type="radio" name="exampleRadios" :checked="plano.tipo_desconto=='abs'" id="exampleRadios2" value="option2">
                    <label class="form-check-label" for="exampleRadios2">
                      Valor Absoluto
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" @change="plano.tipo_desconto=null" type="radio" name="exampleRadios" :checked="plano.tipo_desconto==null" id="exampleRadios2" value="option3">
                    <label class="form-check-label" for="exampleRadios2">
                      Nenhum
                    </label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div v-if="plano.tipo_desconto == 'porcentagem'" class="form-group">
                    <label>Porcentagem</label>
                    <input
                      type="number"
                      class="form-control"
                      placeholder
                      v-model="plano.valor_desconto"
                    />
                  </div>
                  <div v-if="plano.tipo_desconto == 'abs'" class="form-group">
                    <label>Valor Absoluto</label>
                    <money  class="form-control" v-model="plano.valor_desconto" v-bind="money"></money> 
                  </div>
                </div> 
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Status do plano</label>
                    <select class="form-control" v-model="plano.active">
                      <option :value="1">Ativo</option>
                      <option :value="0">Desativado</option>
                    </select>
                  </div>
                </div>  
              <!-- </div> -->
              <div class="form-group">
                <label>Descrição Vendas</label>
                <vue-editor v-model="plano.descricao_vendas" :editorToolbar="customToolbar"></vue-editor>
              </div>
              <div class="form-group">
                <label>Cobertura Plano</label>
                <vue-editor v-model="plano.cobertura" :editorToolbar="customToolbar"></vue-editor>
              </div>
              <div class="form-group">
                <label>Dúvidas Frequentes</label>
                <vue-editor v-model="plano.duvidas" :editorToolbar="customToolbar"></vue-editor>
              </div>
               <p>
                <button
                  href="#0"
                  class="btn_1 medium pull-right"
                  @click="atualizaPlano()"
                >Salvar modificações</button>
              </p>
            </div>
          </div>
        </div>

        <hr />
        <!-- Card de abrangência -->
        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-file"></i>Arquivos
            </h2>
            <p>Adicione ou remova arquivos na lista abaixo</p>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Nome arquivo</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Nome do arquivo"
                  v-model="nomeArquivo"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Arquivo</label>
                <input
                  type="file"
                  class="form-control"
                  id="file"
                  ref="file"
                  @change="handleFileUpload"
                />
              </div>
            </div>
            <div class="col-md-1">
              <button href="#0" class="btn_1 mt-4" @click="addArquivo()">
                <i class="fa fa-plus"></i>
              </button>
            </div>
            <div class="col-md-12">
              <ul>
                <template v-if="arquivos.length > 0">
                  <li :key="arquivo.id" v-for="arquivo of arquivos">
                    {{arquivo.nome}}
                    <i class="fa fa-times" @click="rmArquivo(arquivo.id)"></i>
                  </li>
                </template>
                <li v-else>
                  Nenhum arquivo adicionado
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- /container-fluid-->
      </div>
    </div>
  </div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from "axios";
import moment from "moment";
import { VueEditor } from "vue2-editor";
import { Money } from "v-money";

export default {
  components: {
    VueEditor,
    Money,
  },
  mixins: [funcoesGerais],
  data() {
    return {
      id_plano: this.$route.params.id_plano,
      flagTrue: 1,
      flagFalse: 0,
      arquivos: [],
      operadoras: [],
      operadora: {},
      nomeArquivo: "",
      file: "",
      foto_plano: "",
      listaPlanos: [],
      plano: {
        name: "",
        description: "",
        provider_id: "",
        price: "",
        setup_fee: "",
        ans: "",
        length_interval: 1,
        unit_interval: "Monthly",
        active: '',
        tipo_plano: 0,
        plan_number:'',
        contrato:'',
        TokenAcesso: '',
        recorrencia: '',
        planos_vinculados: [],
        tipo_desconto: 'porcentagem',
        valor_desconto: 0,
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false,
      },
      imagem_foto: "",
      mostraErro: false,
      isLoading: false,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        //['image', 'code-block']
      ],
    };
  },
  created() {
    var self = this;
    var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
    if (user) {
      self.isLoading = true;

      Promise.all([
        ajax("get", "/planos/detalhes/" + self.id_plano + "/adm"),
        ajax("get", "/operadoras")
      ])
      .then(([planosRes, operadorasRes]) => {
        if (planosRes && planosRes.plano) {
          // Set the plano data with proper defaults
          const planoData = planosRes.plano;
          self.plano = {
            ...planoData,
            // Ensure these fields have proper default values
            active: Number(planoData.active || 0),
            recorrencia: Number(planoData.recorrencia || 0),
            tipo_plano: Number(planoData.tipo_plano || 0),
            // Convert monetary values to display format
            price: self.emReais(planoData.price),
            setup_fee: self.emReais(planoData.setup_fee || 0),
            valor_boleto: self.emReais(planoData.valor_boleto || 0)
          };
          if(planoData.planos_vinculados && planoData.planos_vinculados.length > 0){
            planoData.planos_vinculados.forEach(plano => {
              plano.price = self.emReais(plano.price);
              plano.setup_fee = self.emReais(plano.setup_fee || 0);
            });
          }
          
          self.imagem_foto = planoData.foto_plano || '';
          self.arquivos = planosRes.arquivos || [];
          self.operadora = planosRes.operadora || {};
        }
        
        // Set operadoras data
        self.operadoras = Array.isArray(operadorasRes) ? operadorasRes : [];
        this.getPlanosFromUniodonto();
        self.isLoading = false;
      })
      .catch((error) => {
        self.isLoading = false;
        //console.error('Error loading plano details:', error);
        tratamento_requisicao(error, self);
      });
    } else {
      self.$router.replace(self.$route.query.redirect || "/");
    }
  },
  methods: {
    addPlanoVinculado() {
      this.plano.planos_vinculados.push({
        plano_familiar_id: this.plano.id,
        plans_id: "",
        price: "",
        setup_fee: "",
        carencia: "",
        carencia_boleto: "",
        qtd_min: ""
      });
    },
    removePlanoVinculado(index) {
      this.plano.planos_vinculados.splice(index, 1);
    },
    getValoresDoPlano(plan) {
      const base = this.listaPlanos.find(p => p.id === plan.plans_id);
      if (base) {
        plan.price = (base.price/100) || "";
        plan.setup_fee = (base.setup_fee/100) || "";
        plan.carencia = base.carencia || "";
        plan.carencia_boleto = base.carencia_boleto || "";
      }
      //console.log(plan);
    },
    getPlanosFromUniodonto(){
      //console.log(this.plano.provider_id);
        ajax("get", `operadoras/${this.plano.provider_id}/planos/adm`)
        .then((response) => {
          this.isLoading = false;
          this.listaPlanos = response.data;
        })
        .catch((error) => {
          this.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },
    atualizaPlano() {
      const self = this;
      self.isLoading = true;
      
      // Create a copy of the plano object to avoid modifying the original
      const planoData = JSON.parse(JSON.stringify(self.plano));

      if(planoData.qtd_membros==0){
        alert('A quantidade de membros deve ser maior que 0!');
        self.isLoading = false;
        return;
      }
      // Convert price values to cents before sending
      if (Number(self.plano.tipo_plano) === 2 && self.plano.planos_vinculados.length > 0) {
        let precoTotal = 0;
        let setup_feeTotal = 0;

        self.plano.planos_vinculados.forEach((plano, index) => {
          const preco = self.emCentavos(plano.price || 0);
          const setup = plano.setup_fee 
          precoTotal += preco;
          setup_feeTotal += setup;
        });

        planoData.price = precoTotal;
        planoData.setup_fee = setup_feeTotal;
      } else if (planoData.price) {
        planoData.price = this.emCentavos(planoData.price);
      }
      if (planoData.setup_fee) {
        planoData.setup_fee = this.emCentavos(planoData.setup_fee);
      }
      if (planoData.valor_boleto) {
        planoData.valor_boleto = this.emCentavos(planoData.valor_boleto);
      }
      if(planoData.planos_vinculados && planoData.planos_vinculados.length > 0){
        planoData.planos_vinculados.forEach(plano => {
          plano.price = this.emCentavos(plano.price);
          plano.setup_fee = this.emCentavos(plano.setup_fee || 0);
        });
      }
      //console.log(planoData.foto_plano);
      // Create FormData for the request
      const formData = new FormData();
      Object.keys(planoData).forEach(key => {
        if (planoData[key] !== null && planoData[key] !== undefined && key !== "planos_vinculados") {
          formData.append(key, planoData[key]);
        }
      });

      if (Array.isArray(planoData.planos_vinculados) && planoData.planos_vinculados.length > 0) {
        formData.append('planos_vinculados', JSON.stringify(planoData.planos_vinculados));
      }
      
      // If there's a file, append it
      if (self.file) {
        formData.append('foto', self.file);
      }
      if (self.foto_plano) {
        formData.append('foto_plano', self.foto_plano);
      }
      
      // Send the request
    ajax("post", "/planos/" + self.plano.id, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((response) => {
        self.isLoading = false;
        alerta("success", "Sucesso", "Plano atualizado com sucesso!");
        
        // Convert prices back to reais for display
        if (response.plano) {
          self.plano.price = self.emReais(response.plano.price);
          self.plano.setup_fee = self.emReais(response.plano.setup_fee);
          self.plano.valor_boleto = response.plano.valor_boleto ? self.emReais(response.plano.valor_boleto) : null;
          
          // Update the image if it was changed
          if (response.plano.foto) {
            self.imagem_foto = response.plano.foto;
          }
        }
      })
      .catch((error) => {
        self.isLoading = false;
        if (error.response && error.response.data && error.response.data.error) {
          const errorData = error.response.data.error;
          if (typeof errorData === 'object') {
            const errorMessage = Object.values(errorData).join('\n');
            alerta("error", "Erro", errorMessage || "Ocorreu um erro ao atualizar o plano.");
          } else {
            alerta("error", "Erro", errorData || "Ocorreu um erro ao atualizar o plano.");
          }
        } else {
          alerta("error", "Erro", "Não foi possível atualizar o plano. Tente novamente mais tarde.");
        }
      });
    },
    emCentavos(valor) {
      if (!valor) return 0;
      
      return Math.round(valor * 100);
    },
    emReais(valor) {
      return valor ? (valor / 100).toFixed(2) : 0;
    },
    rmArquivo(idArquivo) {
      var self = this;
      self.isLoading = true;
      ajax("delete", "/arquivos/" + idArquivo)
        .then((response) => {
          self.isLoading = false;
            alerta(
               "success",
               "Removido",
               "Arquivo removido com sucesso!"
             );
          let index = self.arquivos.findIndex((x) => x.id == idArquivo);
          self.arquivos.splice(index, 1);
        })
        .catch((error) => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },
    addArquivo() {
      var self = this;
      self.isLoading = true;

      let formData = new FormData();
      formData.append("plan_id", self.id_plano);
      formData.append("file", self.file);
      formData.append("nome", self.nomeArquivo);

      ajax("post", "/upload", formData)
        .then((response) => {
          self.isLoading = false;
          alerta(
              "success",
              "Sucesso",
              "Arquivo adicionado!"
            );
          self.file = "";
          self.nomeArquivo = "";
          self.arquivos.push(response);
        })
        .catch((error) => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },
    handleFileUpload(e) {
      var files = e.target.files;
      this.file = files[0];
    },
    trocaFoto: function ($event) {
      //console.log('Arquivo selecionado:', $event.target.files[0]);
      const file = $event.target.files[0];
      if (!file) return;
      if (!file.type.startsWith('image/')) {
        alert('Por favor, selecione uma imagem válida.');
        return;
      }
      this.foto_plano = file;
      this.imagem_foto = URL.createObjectURL(this.foto_plano);
    },
  },
};
</script>